import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const httpOptions ={
    headers: new HttpHeaders({
        'Content-Type' :'application/x-www-form-urlencoded'
    })
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  apiUrl : string = environment?.apiUrl;
  constructor( private http: HttpClient) { }

  get(url:string){
    return this.http.get<any>(this.apiUrl + url, httpOptions)
  }
  put(url:string,body:any){
    return this.http.put<any>(this.apiUrl + url,body)
  }
  patch(url: string, body: any){
		return this.http.patch<any>(this.apiUrl + url, body)
	}
  post(url:string,body:any){
    return this.http.post<any>(this.apiUrl + url,body)
  }
  delete(url:string){
    return this.http.delete<any>(this.apiUrl + url, httpOptions)
  }
}
